import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import InterestReportTable from "../../../Components/ReportTables/InterestReportTable";
import Loader from "../../../Components/Common/Loader";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function InterestReportNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const userType = localStorage.getItem("partnerType").toLowerCase();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [seg, setSeg] = useState("dpc");
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [totalMTF, setTotalMTF] = useState();
  const [errorResp, setErrorResp] = useState("");
  const [customShow, setCustomShow] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");

  let clientCode = "";

  if (toDate === "" || fromDate === "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
        let firstDay = "";
        let lastDay = "";
        let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
        firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        let lastVal = new Date();
        lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
        setFromDate(firstDay)
        setToDate(lastDay)
  }

  const getInterestReport = async (code, fileView, mainLoader = false) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");

    let payloadValue = {
      clientCode: code || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: seg,
    };
    let encPayload = AESEncryption(payloadValue);
      // userType === "partner"
      //   ? encryptData(JSON.stringify(payloadValue))
      //   : AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.IntrestReportTrade_Report_URL,
        // userType === "partner"
        //   ? Partner_Reports.IntrestReportTrade_Partner_URL
        //   : Dashboard_Client_Report.IntrestReportTrade_Report_URL,
        // userType === "partner" ? `${encPayload}` : 
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
        // userType === "partner"
        //   ? JSON.parse(decryptData(getDetails?.data))
        //   : ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          if (seg === "dpc") {
            //setTotalMTF(res?.data?.totalIntChrg);
            setData(res?.data);
          } else if (seg === "mtf") {
            setData(res?.data);
            setTotalMTF(res?.data?.totalMtf);
          } else if (seg === "prop") {
            setData(res?.data);
            // setTotalMTF(res?.data?.totalAllocationFromPropCount);
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setData();
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setData();
    setErrorGrid(false);
    setSeg(e.target.value);
  };

  const handleFromDateChange = (e) => {
    setData();
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setServerError(false);
    setErrorResp("");
  };
  const handleToDateChange = (e) => {
    setData();
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setServerError(false);
    setErrorResp("");
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");

      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getInterestReport(clientCode, "grid", true);
      } else {
        setData();
      }
    }
  }, []);
  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (fromDate.length > 0 && toDate.length > 0 && seg.length > 0) {
        if (e.target.value) {
          if (
            compareDate(fromDate) &&
            compareDate(toDate) &&
            checkDateRange(fromDate, toDate)
          ) {
            getInterestReport(clientCode, e.target.value, true);
            setErrorResp("");
          } else {
            setErrorResp("Please Select Correct Date");
          }
        }
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const onChangeDuration = () => {
    setData();
    setErrorGrid(false);
    setServerError(false);
    setErrorResp("");
  };
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="pnl-report"
        role="tabpanel"
        aria-labelledby="pnl-report"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    screen="Client Dashboard"
                    onChangeDuration={onChangeDuration}
                    className="report-custom-select"
                  />
                </div>
                {/* <div className="d-flex"> */}
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                />}
                {/* </div> */}
                {/* <div className="d-flex"> */}
                <div className="form-group">
                  <label className="form-label">Segment: </label>
                  <select
                    onChange={handleSegmentChange}
                    className="report-custom-select"
                  >
                    <>
                      <option value="dpc">Delay Payment</option>
                      <option value="mtf">MTF</option>
                      {userType !== "partner" ? <option value="prop">PROP</option> : ""}
                    </>
                  </select>
                </div>
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {Constants.Submit}
            </button>
          </div>

          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              value="excel"
              onClick={handleOnClick}
              className="generate-button excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data ? (
        <div>
          <InterestReportTable data={data} seg={seg} totalMTF={totalMTF} />
        </div>
      ) : serverError ? (
        <h4 className="report-error-message">{noDataFound(serverError)}</h4>
      ) : errorGrid ? (
        noDataFound(errorGrid)
      ) : (
        ""
      )}
    </>
  );
}
export default InterestReportNew;
